import * as React from 'react';
import { IState, IPostItem } from '../../redux/interface';
import { connect } from 'react-redux';
import action from '../../redux/action/post';
import './index.scss';
import UploadDialog from '../../components/UploadDialog';
import EmojiDialog from '../../components/EmojiDialog';
import AddTitleDialog from '../../components/AddTitleDialog';
import VoteDialogAntd from '../../components/VoteDialogAntd';
// import DragSortingTable form '../../components/DragTable/index';
import { WithBaiduMediaUpload } from '../../components/HOC/BaiduMediaUpload';
import { inject } from 'mobx-react';
import Arr from '@util/array';
import tool from '@util/tool';
import * as classnames from 'classnames';
import toast from '@util/toast';
import { Modal, Button, Input } from 'antd';
import moment from 'moment';
import Item from 'antd/lib/list/Item';
import Sortable from 'sortablejs';
import Group from '../../components/Group';
import ScheduledPublishTime from '../../components/ScheduledPublishTime';

interface IProp {
    setTitle: (title: string) => void;
    setValidAtMax: (title: string) => void;
    setValidAtMin: (title: string) => void;
    setContentByIndex: (index: number, content: IPostItem) => void;
    setContent: (content: IPostItem[]) => void;
    setVoteListTop: (content: IPostItem[]) => void;
    setVoteListBottom: (content: IPostItem[]) => void;
    setCurrentInputIndex: (index: number) => void;
    setCurrentTarget: (target: React.ReactInstance) => void;
    setHasFocusTitle: (hasTitle: boolean) => void;
    insertTitleByIndex: (n: number, s: IPostItem) => void;
    insertContentByIndex: (idx: number, obj: IPostItem) => void;
    editTitleByIndex: (n: number, s: IPostItem) => void;
    removeContentByIndex: (n: number) => void;
    title: string;
    voteListTop: IPostItem[];
    voteListBottom: IPostItem[];
    validAtMax: string;
    validAtMin: string;
    cover: string;
    setCurrentIndex: (index: number) => void;
    content: IPostItem[];
    scrollTo: number;
    controlToggle: (n: number, type: 'add' | 'edit') => void;
    setKeyboradHeight: (keyboradHeight: number) => void;
    keyboradHeight: number;
    forwardedRef: (view: any) => void;
    currentInputIndex: number;
    currentIndex: number;
    currentTarget: any;
    emojiVisible: boolean;
    hasFocusTitle: boolean;
    emojiBoxHeight: number;
    setEmptyViewHeight: (height: number) => void;
    emptyViewHeight: number;
    setSelectionEnd: (end: number) => void;
    getStsWrite: any;
    getStsUpload: any;
    setCover: (src: string) => void;
    setCoverPixel: (pixel: string) => void;
    errorStatus: boolean;
    errorContent: string;
    coverPixel: string;
    store: any;
    groupId: string;
    setGroupId: (groupId: string) => void;
}
let currentEditPicId: any;
@WithBaiduMediaUpload(inject('store'))
class CreateEditPics extends React.Component<IProp, any> {
    public textareaRef: any[] = [];
    public UploadDialogIni: any;
    public voteModal: any;
    public EmojiDialogIni: any;
    public AddTitleDialogIni: any;
    public AddVoteDialogIni: any;
    public currentTextArea: HTMLTextAreaElement;
    public currentIndex: number;
    public currentInputIndex: number;
    public currentInputSelectIndex: number;
    public hasFocusTitle: boolean = false;
    public imgList: any = [];
    private actionType = '';
    constructor(props) {
        super(props);
        this.state = {
            voteDate: [],
            voteImgList: [],
            voteListTop: [],
            voteListBottom: [],
            isNewVote: false,
            isImageLinkVisible: false,
            currImge: null,
            currImgeObj: {},
            currImgEl: {},
            hasCurrLink: '',
            releaseTime: '',
            releaseType: ''
        };
        this.UploadDialogIni = UploadDialog.init({
            imageUploadFun: this.imgUploadCheck,
            videoUploadFun: this.videoUploadCheck
        });
        this.EmojiDialogIni = EmojiDialog.init({
            selectCallback: this.selectCallback
        });
        this.AddTitleDialogIni = AddTitleDialog.init({
            confirmCallback: this.addContentTitle,
            editCallback: this.editContentTitle
        });
        // this.AddVoteDialogIni = VoteDialogAntd;
        const id = tool.getQueryString('id');
        if (id) {
            currentEditPicId = id;
            this.getDetail(id);
        }
        this.voteModal = React.createRef();
    }

    public componentDidMount() {
        const that = this;
        new Sortable(document.getElementById('dragVoteTop'), {
            animation: 150,
            ghostClass: 'blue-background-class',
            // 结束拖拽
            onEnd(/**Event*/evt) {
                const voteListTop = that.state.voteListTop.slice();
                const currentVote = voteListTop.splice(evt.oldIndex, 1)[0];
                voteListTop.splice(evt.newIndex, 0, currentVote);
                that.setState({
                    voteListTop
                });
            },
        });
        new Sortable(document.getElementById('dragVoteBottom'), {
            animation: 150,
            ghostClass: 'blue-background-class',
            // 结束拖拽
            onEnd(/**Event*/evt) {
                const voteListBottom = that.state.voteListBottom.slice();
                const currentVote = voteListBottom.splice(evt.oldIndex, 1)[0];
                voteListBottom.splice(evt.newIndex, 0, currentVote);
                that.setState({
                    voteListBottom
                });
            }
        });

        const params = new URLSearchParams(window.location.search);
        const groupId = params.get('groupId');
        this.groupIdChange(groupId);

    }
    public editImgLink = (e, index) => {
        const { content } = this.props;
        this.setState({
            currImge: index,
            currImgeObj: content[index],
            isImageLinkVisible: true,
            currImgEl: e.target,
            hasCurrLink: JSON.parse(JSON.stringify(content[index]))
        });
    };
    public addLinkMsgToImg = () => {
        const { currImge, currImgeObj, currImgEl } = this.state;
        // this.props.content[currImge] = currImgeObj;
        this.props.setContentByIndex(currImge, currImgeObj);
        if (currImgeObj.imageHref) {
            currImgEl.style.borderWidth = '1px';
            currImgEl.style.borderStyle = 'solid';
            currImgEl.style.borderColor = '#FF0000';
        } else {
            currImgEl.style.border = 'none';
        }
        this.setState({
            currImge: -1,
            currImgeObj: { imageHref: '' },
            isImageLinkVisible: false,
            currImgEl: null
        });
    };
    public cancelLinkMsgToImg = () => {
        const { currImgeObj, hasCurrLink, currImge } = this.state;
        this.props.setContentByIndex(currImge, hasCurrLink);
        this.setState({
            currImgeObj: hasCurrLink,
            isImageLinkVisible: false,
            currImgEl: null,
            currImge: -1
        });
        // this.setState({

        //   currImgeObj: {imageHref:''},

        // });
    };
    public getDetail = id => {
        this.props.store.getDetail
            .get(id)
            .then(res => {
                if (res.group.groupId) {
                    this.groupIdChange(`${res.group.groupId}`);
                }
                if (res.releaseTime) {
                   this.setState({
                       releaseTime: res.releaseTime,
                       releaseType: 1
                   });
               } else {
                   this.setState({
                       releaseType: 1
                   });
               }
                const title = res.title;
                const validAtMax = res.validAtMax;
                const validAtMin = res.validAtMin;
                const cover = res.surfacePlot;
                const coverPixel = res.surfacePlotFixel;
                const voteList = []; // 投票 >state > div  open dialog init data
                const voteListTop = []; // 投票 >state > div  open dialog init data
                const voteListBottom = []; // 投票 >state > div  open dialog init data
                const content = []; // 富文本编辑内容
                let isTopVote = true;
                res.graphicDetails.forEach(
                    (
                        item: {
                            type: number;
                            content: string;
                            validAtMax: string;
                            validAtMin: string;
                            url: string;
                            width?: number;
                            height?: number;
                            place?: string;
                            desc?: string;
                            surfacePlot?: string;
                            pixel?: string;
                            playTime?: string;
                            videoId?: string;
                            voteOptions?: any[];
                            maxChoice?: number;
                            isAnonymity?: boolean;
                            imageHref?: any;
                        },
                        index: number
                    ): any => {
                        switch (item.type) {
                            case 1:
                              isTopVote = false;
                              content.push( { value: item.content, type: 'title' });
                              break;
                            case 2:
                                if (item.content.length !== 0) {
                                    isTopVote = false;
                                }
                                content.push({ value: item.content, type: 'text' });
                                break;
                            case 3:
                                isTopVote = false;
                                content.push( {
                                  desc: item.content,
                                  pixel: item.pixel,
                                  type: 'image',
                                  value: item.url,
                                  imageHref: item.imageHref
                                      ? item.imageHref.url
                                      : ''
                              });
                                break;
                            case 4:
                                isTopVote = false;
                                content.push({
                                  desc: item.content,
                                  pixel: item.pixel,
                                  time: item.playTime,
                                  videoSurface: item.surfacePlot,
                                  videoId: item.videoId,
                                  type: 'video',
                                  value: item.url
                              }) ;
                                break;
                            case 5:
                            case 6:
                            case 7:
                                let voteType;
                                const images = [];
                                if (item.type === 5) {
                                    voteType = 'singleText';
                                } else if (item.type === 6) {
                                    voteType = 'single';
                                } else {
                                    voteType = 'multiple';
                                }
                                item.voteOptions.forEach(item => {
                                    images.push({url: item.url});
                                });
                                if (isTopVote) {
                                    voteListTop.push({
                                        value: item.content,
                                        type: 'vote',
                                        date: [moment(validAtMin), moment(validAtMax)],
                                        isTop: true,
                                        voteImgList: {
                                            images: item.voteOptions
                                        },
                                        isAnonymity: item.isAnonymity ? 1 : 0,
                                        images,
                                        voteData: {
                                            date: [moment(validAtMin), moment(validAtMax)],
                                            options: item.voteOptions,
                                            type: voteType,
                                            images,
                                            isAnonymity: item.isAnonymity ? 1 : 0,
                                            maxChoice: item.maxChoice,
                                        }
                                    }) ;
                                } else {
                                    voteListBottom.push({
                                        value: item.content,
                                        type: 'vote',
                                        date: [moment(validAtMin), moment(validAtMax)],
                                        voteImgList: {
                                            images: item.voteOptions
                                        },
                                        images,
                                        isAnonymity: item.isAnonymity ? 1 : 0,
                                        isTop: false,
                                        voteData: {
                                            date: [moment(validAtMin), moment(validAtMax)],
                                            options: item.voteOptions,
                                            type: voteType,
                                            images,
                                            isAnonymity: item.isAnonymity ? 1 : 0,
                                            maxChoice: item.maxChoice,
                                        }
                                    }) ;
                                }
                                break;
                        }
                    }
                );
                this.props.setTitle(title);
                this.props.setValidAtMax(validAtMax);
                this.props.setValidAtMin(validAtMin);
                this.setState({
                    voteListTop,
                    voteListBottom
                });
                this.props.setCover(cover);
                this.props.setCoverPixel(coverPixel);
                // ok
                this.props.setContent(content);
                // 投票列表
            })
            .catch(err => {});
    };
    public submitBtn = () => {
        const { store, title, cover, content, coverPixel, groupId } = this.props;
        const { releaseTime } = this.state;
        let list = content;
        const param_box: any = {};
        const param: any = {};
        if (!title) {
            toast.error('请输入文章标题');
            return;
        }
        if (!cover) {
            toast.error('请上传文章封面图');
            return;
        }
        if (list.length === 1 && list[0].value.length === 0) {
            toast.error('请输入正文内容');
            return;
        }
        if (this.state.voteListTop && this.state.voteListTop.length > 0) {
            list = this.state.voteListTop.concat(list);
        }
        if (this.state.voteListBottom && this.state.voteListBottom.length > 0) {
            list = list.concat(this.state.voteListBottom);
        }
        param.title = title;
        param.surfacePlot = cover;
        param.surfacePlotFixel = coverPixel;
        param.groupId = groupId;
        if (releaseTime) {
            if (moment(releaseTime).valueOf() < Date.now()) {
                toast.error('仅支持选择此刻之后14天时间');
                return;
            }
            param.releaseTime = releaseTime;
        }
        param.customGraphicDetailForms = list.map(
            (
                item: {
                    type: string;
                    value: string;
                    width?: number;
                    height?: number;
                    place?: string;
                    desc?: string;
                    videoSurface?: string;
                    pixel?: string;
                    time?: string;
                    videoId?: string;
                    voteData?: any;
                    maxChoice?: number;
                    isAnonymity?: boolean;
                    imageHref?: string;
                },
                index: number
            ): any => {
                switch (item && item.type) {
                    case 'text':
                        return { content: item.value, type: 2 };
                    case 'image':
                        return {
                            content: item.desc,
                            pixel: item.pixel,
                            type: 3,
                            url: item.value,
                            imageHref: item.imageHref
                        };
                    case 'video':
                        return {
                            content: item.desc,
                            pixel: item.pixel,
                            playTime: item.time,
                            surfacePlot: item.videoSurface,
                            videoId: item.videoId,
                            type: 4,
                            url: item.value
                        };
                    case 'title':
                        return { content: item.value, type: 1 };
                    case 'vote':
                        param.vote = true;
                        param.validAtMin = item.voteData.validAtMin;
                        param.validAtMax = item.voteData.validAtMax;
                        let voteType;
                        const optionType = 8; // 单选、多选投票选项值的类型
                        const singleType = 6; // 单选投票
                        const multipleType = 7; // 多选投票
                        const questionType = 5; // 问卷
                        const images = item.voteData.images;
                        if (item.voteData.type === 'single') {
                            voteType = singleType;
                        } else if (item.voteData.type === 'multiple') {
                            voteType = multipleType;
                        } else {
                            voteType = questionType;
                        }
                        const voteObj = item.voteData.options.map(
                            (voteItem, index) => {
                                if (item.voteData.type) {
                                    return {
                                        content: voteItem.content,
                                        url:
                                            images && images[index]
                                                ? images[index].url
                                                : '',
                                        type: optionType
                                    };
                                }
                            }
                        );
                        return [
                            {
                                content: item.value,
                                type: voteType,
                                maxChoice: item.voteData.maxChoice,
                                isAnonymity: item.voteData.isAnonymity
                            },
                            ...voteObj
                        ];
                }
            }
        );
        // 验证授为是否有空格 么有空格加上
        if (param.customGraphicDetailForms[0] && param.customGraphicDetailForms[0].type !== 2) {
            param.customGraphicDetailForms.unshift({
                type: 2,
                content: ''
            });
        }
        const formsLength = param.customGraphicDetailForms.length;
        if (
            formsLength > 0 &&
            param.customGraphicDetailForms[formsLength - 1] &&
            param.customGraphicDetailForms[formsLength - 1].type !== 2
        ) {
            param.customGraphicDetailForms.push({
                type: 2,
                content: ''
            });
        }
        param.customGraphicDetailForms = [].concat(
            ...Object.values(param.customGraphicDetailForms)
        );
        // 处理bos图片签名
        for (const item of param.customGraphicDetailForms) {
          if (item.url) {
            item.url = tool.removeQueryFromHtml(item.url);
          }
        }
        param_box.customGraphic = param;
        if (currentEditPicId) {
            param.productId = currentEditPicId;
            store.addPics
                .edit_v2_request({
                    post: param_box,
                    productId: currentEditPicId
                })
                .then(res => {
                    window.location.href = '/edit-pics';
                })
                .catch(err => {
                    toast.error(err.msg);
                });
        } else {
            store.addPics
                .set_v2_request({ post: param_box })
                .then(res => {
                    window.location.href = '/edit-pics';
                })
                .catch(err => {
                    toast.error(err.msg);
                });
        }
    };
    public showVideoPanel = () => {
        this.UploadDialogIni.upload('video');
    };
    public showImagePanel = () => {
        this.UploadDialogIni.upload('image', true);
    };
    public removeImageOrVideo = index => {
        const r = confirm('确定从文章中删除？');
        if (r == true) {
            this.props.removeContentByIndex(index);
            this.currentIndex = index - 1;
            const currentNewIndex = Math.max(
                this.props.currentInputIndex - 2,
                0
            );
            if (index <= this.currentInputIndex) {
                this.currentInputIndex = currentNewIndex;
                this.currentIndex = currentNewIndex;
            }
        }
    };

    public imgUploadCheck = imgFiles => {
        if (!this.props.content[this.currentInputIndex]) {
            return;
        }
        if (!this.hasFocusTitle) {
            const end = this.currentInputSelectIndex || 0;
            let splitStart: string;
            let splitEnd: string;
            if (end || end === 0) {
                splitStart =
                    (this.props.content[this.currentInputIndex].value &&
                        this.props.content[this.currentInputIndex].value.slice(
                            0,
                            end
                        )) ||
                    '';
                splitEnd =
                    (this.props.content[this.currentInputIndex].value &&
                        this.props.content[this.currentInputIndex].value.slice(
                            end
                        )) ||
                    '';
            }
            let inserIndex: number = 0;
            Arr.arrForEach(imgFiles, (file, idx) => {
                this.props.getStsWrite(file, data => {
                    if (data.name || data.url) {
                        if (JSON.stringify(Arr[0]) === JSON.stringify(file)) {
                            this.props.setContentByIndex(
                                this.currentInputIndex,
                                {
                                    type: 'text',
                                    value: splitStart
                                }
                            );
                        }
                        inserIndex = this.currentInputIndex + 2 * idx; // 每次从图片下方textinput开始插入
                        this.props.insertContentByIndex(inserIndex, {
                            type: 'image',
                            value: data.url,
                            pixel: data.pixel,
                            desc: ''
                        });
                        if (idx === imgFiles.length - 1) {
                            if (splitEnd.length > 0) {
                                // 如果有内容添加到图片下面的textinput里面
                                this.props.setContentByIndex(inserIndex + 2, {
                                    type: 'text',
                                    value: splitEnd
                                });
                            }
                            this.currentInputIndex = inserIndex + 2;
                            this.currentIndex = inserIndex + 2;
                        }
                    } else {
                    }
                });
            });
        }
    };
    public videoUploadCheck = videoFiles => {
        if (!this.props.content[this.currentInputIndex]) {
            return;
        }
        if (!this.hasFocusTitle) {
            const end = this.currentInputSelectIndex || 0;
            let splitStart: string;
            let splitEnd: string;
            if (end || end === 0) {
                splitStart =
                    (this.props.content[this.currentInputIndex].value &&
                        this.props.content[this.currentInputIndex].value.slice(
                            0,
                            end
                        )) ||
                    '';
                splitEnd =
                    (this.props.content[this.currentInputIndex].value &&
                        this.props.content[this.currentInputIndex].value.slice(
                            end
                        )) ||
                    '';
            }
            let inserIndex: number = 0;
            Arr.arrForEach(videoFiles, (file, idx) => {
                this.props.getStsUpload(file, data => {
                    if (data.videoId) {
                        if (JSON.stringify(Arr[0]) === JSON.stringify(file)) {
                            this.props.setContentByIndex(
                                this.currentInputIndex,
                                {
                                    type: 'text',
                                    value: splitStart
                                }
                            );
                        }
                        inserIndex = this.currentInputIndex + 2 * idx; // 每次从图片下方textinput开始插入
                        this.props.insertContentByIndex(inserIndex, {
                            type: 'video',
                            value: data.PlayInfo[0].playURL,
                            videoSurface: data.snapshots[0],
                            time: tool.getTime(data.duration),
                            videoId: data.videoId,
                            pixel: data.pixel,
                            desc: ''
                        });
                        if (idx === videoFiles.length - 1) {
                            if (splitEnd.length > 0) {
                                // 如果有内容添加到图片下面的textinput里面
                                this.props.setContentByIndex(inserIndex + 2, {
                                    type: 'text',
                                    value: splitEnd
                                });
                            }
                            this.currentInputIndex = inserIndex + 2;
                            this.currentIndex = inserIndex + 2;
                        }
                    } else {
                    }
                });
            });
        }
    };
    public selectCallback = (emoji: string) => {
        if (this.currentTextArea) {
            const end = this.currentInputSelectIndex;
            let value = '';
            const ItemValue = this.props.content[this.currentInputIndex].value;
            const before = (ItemValue && ItemValue.slice(0, end)) || '';
            const after = (ItemValue && ItemValue.slice(end)) || '';
            if (end) {
                value = before + emoji + after;
                this.currentInputSelectIndex = end + emoji.length;
            } else {
                value = ItemValue ? ItemValue + emoji : emoji;
            }
            this.props.setContentByIndex(this.currentInputIndex, {
                type: 'text',
                value
            });
        }
    };
    public editContentTitle = (title: string): any => {
        this.props.editTitleByIndex(this.currentIndex, {
            type: 'title',
            value: tool.trimStr(title)
        });
    };
    public addContentTitle = (title: string): any => {
        if (!title) {
            return false;
        }
        if (!this.props.content[this.currentInputIndex]) {
            return;
        }
        const value = title.slice(0, 30);
        const end = this.currentInputSelectIndex || 0;
        let splitStart: string;
        let splitEnd: string;
        if (end || end === 0) {
            splitStart =
                (this.props.content[this.currentInputIndex].value &&
                    this.props.content[this.currentInputIndex].value.slice(
                        0,
                        end
                    )) ||
                '';
            splitEnd =
                (this.props.content[this.currentInputIndex].value &&
                    this.props.content[this.currentInputIndex].value.slice(
                        end
                    )) ||
                '';
            this.props.setContentByIndex(this.currentInputIndex, {
                type: 'text',
                value: splitStart
            });
            this.props.insertTitleByIndex(this.currentInputIndex, {
                type: 'title',
                value: tool.trimStr(title)
            });
            this.props.setContentByIndex(this.currentInputIndex + 2, {
                type: 'text',
                value: splitEnd
            });
        }
        this.currentInputIndex = this.currentInputIndex + 2;
        this.currentIndex = this.currentInputIndex + 2;
    };
    public addContentVote = (data: any, isTop: Boolean, index: number, actionType: string) => {
        this.setState({
            voteDate: data.date
        });
        if (!data.title) {
            return false;
        }
        const voteImgList = this.state.voteImgList;
        data.value = data.title;
        data.isTop = isTop;
        data.voteData = {};
        data.voteData.type = data.type;
        data.voteData.isAnonymity = data.isAnonymity;
        data.voteData.maxChoice = data.maxChoice;
        data.voteData.validAtMin = data.date[0].valueOf();
        data.voteData.validAtMax = data.date[1].valueOf();
        data.voteData.options = data.options;
        data.voteData.images = voteImgList.images;
        data.images = voteImgList.images;
        data.type = 'vote';
        let result = [];
        if (isTop) {
            result = this.state.voteListTop.slice();
            if (actionType !== 'edit') {
                result.push(data);
            } else {
                result[index] = data;
            }
            this.setState({
                voteListTop: result
            });
        } else {
            result = this.state.voteListBottom.slice();
            if (actionType !== 'edit') {
                result.push(data);
            } else {
                result[index] = data;
            }
            this.setState({
                voteListBottom: result
            });
        }
    };
    public setCover = (e: React.ChangeEvent<HTMLInputElement>) => {
        const imgFiles = e.target.files;
        Arr.arrForEach(imgFiles, file => {
            this.props.getStsWrite(file, data => {
                if (data.name || data.url) {
                    this.props.setCover(data.url);
                    this.props.setCoverPixel(data.pixel);
                } else {
                }
            });
        });
    };
    public handleValueChange = (
        event: React.ChangeEvent<HTMLTextAreaElement>,
        index: number
    ) => {
        this.props.setContentByIndex(index, {
            type: 'text',
            value: event.target.value
        });
    };
    public handleResourceDescChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        index: number
    ) => {
        const preDesc = this.props.content[index].desc;
        const valueCheck = tool.filterInput(event.target.value);
        let desc = valueCheck;
        if (valueCheck.length > 100) {
            if (preDesc && preDesc.length === 100) {
                desc = preDesc;
            } else {
                desc = valueCheck.substr(0, 100);
            }
        }
        this.props.setContentByIndex(index, {
            ...this.props.content[index],
            desc
        });
    };

    public imgInputChange = (e, index, type, voteImgList) => {
        this.actionType = type;
        if (type === 'change') {
            this.imgList = [];
            this.setState({ voteImgList: [] });
            return;
        }
        const files = e.target.files;
        Arr.arrForEach(files, file => {
            this.props.getStsWrite(file, data => {
                const imgInfo: any = {};
                if (data.url) {
                    imgInfo.url = data.url;
                    imgInfo.imageRes = data.pixel;
                    const isNewVote = this.state.isNewVote;
                    if (isNewVote || this.actionType === 'change') {
                        this.imgList = [];
                    }
                    if (voteImgList && voteImgList.length > 0) {
                        this.imgList = voteImgList.slice();
                    }
                    this.imgList[index] = imgInfo;
                    const param: any = {};
                    param.images = this.imgList;
                    this.setState({ voteImgList: param, isNewVote: false });
                } else {
                    toast.error('图片上传失败');
                }
            });
        });
    };
    public groupIdChange = (val: string ) => {
        this.props.setGroupId(val);
    };
    public getIdFromURL = (url= window.location.href) => {
        const parsedUrl = new URL(url);
        return parsedUrl.searchParams.get('id') || '';
    }
    public render() {
      const {
          content,
          validAtMax,
          validAtMin,
          title,
          cover,
          errorStatus,
          errorContent,
          ...other
      } = this.props;
      const { voteImgList, voteListTop, voteListBottom, isImageLinkVisible, currImgeObj } = this.state;
      return (
          <div className="CreateEditPicsMainBox">
              <div className="head-wrap">
                  {/* <img src={cover} alt="" /> */}
                  {!cover ? (
                      <div className="uploadBefore">
                          <div className="uploadBeforeIcon">
                              <img
                                  src={require('../../assets/images/commonImg/loseImgIco.png')}
                                  alt=""
                              />
                              <p>点击添加封面图片</p>
                              <p>支持JPG、PNG图片</p>
                          </div>
                          <input
                              type="file"
                              name="cover"
                              id=""
                              value=""
                              onChange={e => this.setCover(e)}
                          />
                      </div>
                  ) : (
                      <div className="cropImg">
                          <img src={cover} alt="" />
                      </div>
                  )}
                  <div className="picsTitle">
                      <input
                          type="text"
                          id="_j_title"
                          value={title}
                          placeholder="添加文章标题"
                          maxLength={30}
                          onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                              this.props.setTitle(e.target.value);
                          }}
                      />
                  </div>
                  <div hidden={!cover} className="setBtn">
                      更换封面
                      <input
                          type="file"
                          name=""
                          id=""
                          value=""
                          onChange={e => this.setCover(e)}
                      />
                  </div>
              </div>
              <div className="editPicsContent">
                <div id="dragVoteTop">
                {voteListTop && voteListTop.map((
                          item: {
                              type: string;
                              value: string;
                              width?: number;
                              height?: number;
                              place?: string;
                              desc?: string;
                              imageHref?: string;
                              videoSurface?: string;
                              showImage?: boolean;
                              voteData?: any;
                              images?: any;
                          },
                          index: number
                      ): any => {
                        return (
                            <div
                                key={`${index}-${item.value}`}
                                className="paragraph-title vote-title">
                                <h3>【投票】{item.value}</h3>
                                <div className="title-check-tool">
                                    <span
                                        onClick={() => {
                                            item.voteData.date = this.state.voteDate;
                                            this.setState({
                                                voteImgList: {
                                                    images: item.images
                                                }
                                            });
                                            this.voteModal.current.showModal(
                                                item,
                                                'edit', index, this.state.validAtMax, this.state.validAtMin
                                            );
                                            // this.AddTitleDialogIni.show(
                                            //     item
                                            // );
                                        }}>
                                        编辑
                                    </span>
                                    <span
                                        onClick={() => {
                                            const r = confirm(
                                                '提示,确认删除该内容？'
                                            );
                                            if (r == true) {
                                                const list = this.state.voteListTop.slice();
                                                list.splice(index, 1);
                                                this.setState({
                                                    voteListTop: list
                                                });
                                            }
                                        }}>
                                        删除
                                    </span>
                                </div>
                            </div>
                        );
                      })
                    }
                    </div>
                  {content.map(
                      (
                          item: {
                              type: string;
                              value: string;
                              width?: number;
                              height?: number;
                              place?: string;
                              desc?: string;
                              imageHref?: string;
                              videoSurface?: string;
                              showImage?: boolean;
                              voteData?: any;
                          },
                          index: number
                      ): any => {
                          switch (item && item.type) {
                              case 'text':
                                  return (
                                      <textarea
                                          key={index}
                                          className="textarea"
                                          name="picsParagraph"
                                          placeholder={
                                              content.length === 1
                                                  ? '一起聊聊吧~'
                                                  : ''
                                          }
                                          onChange={(
                                              e: React.ChangeEvent<
                                                  HTMLTextAreaElement
                                              >
                                          ) =>
                                              this.handleValueChange(e, index)
                                          }
                                          onFocus={(
                                              e: React.FocusEvent<
                                                  HTMLTextAreaElement
                                              >
                                          ) => {
                                              this.currentInputIndex = index;
                                              this.currentIndex = index;
                                              this.currentTextArea = e.target;
                                          }}
                                          onSelect={() => {
                                              if (this.currentTextArea) {
                                                  this.currentInputSelectIndex = this.currentTextArea.selectionEnd;
                                              }
                                          }}
                                          value={item.value}
                                          id=""
                                          rows={1}></textarea>
                                  );
                              case 'image':
                                  return (
                                      <div key={index} className="image-wrap">
                                          <span
                                              className="editor-img-wrapper-close"
                                              onClick={e => {
                                                  e.stopPropagation();
                                                  this.removeImageOrVideo(
                                                      index
                                                  );
                                              }}></span>
                                          <img
                                              src={item.value}
                                              alt=""
                                              data-imagehref={item.imageHref}
                                              onClick={e => {
                                                  this.editImgLink(e, index);
                                              }}
                                              style={{
                                                  border: `${
                                                      item.imageHref
                                                          ? '1px solid #FF0000'
                                                          : 'none'
                                                  }`
                                              }}
                                          />
                                          <div className="editor-img-caption-wrapper">
                                              <input
                                                  className="editor-img-caption-ipt"
                                                  maxLength={100}
                                                  placeholder="添加图片注释(最多100字)"
                                                  value={item.desc}
                                                  onChange={(
                                                      event: React.ChangeEvent<
                                                          HTMLInputElement
                                                      >
                                                  ) => {
                                                      this.handleResourceDescChange(
                                                          event,
                                                          index
                                                      );
                                                  }}
                                              />
                                          </div>
                                      </div>
                                  );
                              case 'video':
                                  return (
                                      <div key={index} className="video-wrap">
                                          <span
                                              className="videoClose"
                                              onClick={() =>
                                                  this.removeImageOrVideo(
                                                      index
                                                  )
                                              }></span>
                                          <img
                                              className="videoBox"
                                              src={item.videoSurface}
                                              data-videoid="mda-kd8r1g8s1g004ch9"
                                              alt="文字视频"
                                              data-playurl="http://ikkf7jf9fbx5dvkakyu.exp.bcevod.com/mda-kd8r1g8s1g004ch9/mda-kd8r1g8s1g004ch9.mp4"
                                              data-pixel="640*360"
                                          />
                                          {/*  <div className="cover">
                                              更换封面图
                                          </div> */}
                                          <div className="tip">
                                              视频尚未发布，暂时无法播放
                                          </div>
                                          <span className="videoPlay"></span>
                                          <div className="editor-img-caption-wrapper">
                                              <input
                                                  className="editor-img-caption-ipt"
                                                  maxLength={100}
                                                  placeholder="添加视频注释(最多100字)"
                                                  value={item.desc}
                                                  onChange={(
                                                      event: React.ChangeEvent<
                                                          HTMLInputElement
                                                      >
                                                  ) => {
                                                      this.handleResourceDescChange(
                                                          event,
                                                          index
                                                      );
                                                  }}
                                              />
                                          </div>
                                      </div>
                                  );
                              case 'title':
                                  return (
                                      <div
                                          key={index}
                                          className="paragraph-title">
                                          <h3>{item.value}</h3>
                                          <div className="title-check-tool">
                                              <span
                                                  onClick={() => {
                                                      this.currentIndex = index;
                                                      this.AddTitleDialogIni.show(
                                                          item.value
                                                      );
                                                  }}>
                                                  编辑
                                              </span>
                                              <span
                                                  onClick={() => {
                                                      const r = confirm(
                                                          '提示,确认删除该内容？'
                                                      );
                                                      if (r == true) {
                                                          this.props.removeContentByIndex(
                                                              index
                                                          );
                                                          this.currentIndex =
                                                              index - 1;
                                                      }
                                                  }}>
                                                  删除
                                              </span>
                                          </div>
                                      </div>
                                  );
                          }
                      }
                  )}
                <div id="dragVoteBottom">
                  {voteListBottom && voteListBottom.map((
                          item: {
                              type: string;
                              value: string;
                              width?: number;
                              height?: number;
                              place?: string;
                              desc?: string;
                              imageHref?: string;
                              videoSurface?: string;
                              showImage?: boolean;
                              voteData?: any;
                              images?: any;
                          },
                          index: number
                      ): any => {
                        return (
                            <div
                                key={`${index}-${item.value}`}
                                className="paragraph-title vote-title">
                                <h3>【投票】{item.value}</h3>
                                <div className="title-check-tool">
                                    <span
                                        onClick={() => {
                                            item.voteData.date = this.state.voteDate;
                                            this.setState({
                                              voteImgList: {
                                                  images: item.images
                                              }
                                          });
                                            this.voteModal.current.showModal(
                                              item,
                                              'edit', index, this.state.validAtMax, this.state.validAtMin
                                          );
                                        }}>
                                        编辑
                                    </span>
                                    <span
                                        onClick={() => {
                                            const r = confirm(
                                                '提示,确认删除该内容？'
                                            );
                                            if (r == true) {
                                                const list = this.state.voteListBottom.slice();
                                                list.splice(index, 1);
                                                this.setState({
                                                    voteListBottom: list
                                                });
                                            }
                                        }}>
                                        删除
                                    </span>
                                </div>
                            </div>
                        );
                      })
                    }
                    </div>
                  <div className="group-tool">
                      <span className="comment-label">圈子</span>
                      <Group  disabled={this.getIdFromURL()} value={this.props.groupId} onChange={this.groupIdChange}  placeholder="请选择"></Group>
                  </div>
                    <br />
                  <ScheduledPublishTime
                      releaseType={this.state.releaseType}
                      releaseTime={this.state.releaseTime}
                      releaseTimeChange={(releaseTime) => {
                        this.setState({
                            releaseTime
                        });
                      }}
                      releaseTypeChange={
                        (releaseType) => {
                            this.setState({
                                releaseType
                            });
                        }
                      }

                  />
              </div>
              <div className="edit-tool">
                  <ul>
                      <li onClick={() => this.showImagePanel()}>插入图片</li>
                      <li onClick={() => this.EmojiDialogIni.show()}>
                          插入表情
                      </li>
                      <li onClick={() => this.showVideoPanel()}>插入视频</li>
                      <li onClick={() => this.AddTitleDialogIni.show()}>
                          插入标题
                      </li>
                      <li
                          onClick={() => {
                              this.voteModal.current.showModal(null, 'add');
                              this.setState({
                                  voteImgList: [],
                                  isNewVote: true
                              });
                          }}>
                          插入投票
                      </li>
                      {/*                         <li>
                          发布
                      </li> */}
                  </ul>
              </div>
              <div className="post-tool">
                  <ul>
                      <li>
                          <Button
                              type="primary"
                              onClick={() => this.submitBtn()}>
                              发布文章
                          </Button>
                      </li>
                  </ul>
              </div>
              <div className={classnames('bigScreen', { hide: errorStatus })}>
                  <div className="errInfo">{errorContent}</div>
              </div>
              <Modal
                  title="请编辑图片超链接"
                  visible={isImageLinkVisible}
                  onOk={this.addLinkMsgToImg}
                  onCancel={this.cancelLinkMsgToImg}>
                  <div className="img-link-modal">
                      <span className="label-name">跳转链接：</span>
                      <Input
                          type="text"
                          value={currImgeObj.imageHref}
                          placeholder="请编辑超链接"
                          onChange={e => {
                              this.setState({
                                  currImgeObj: Object.assign(currImgeObj, {
                                      imageHref: e.target.value || ''
                                  })
                              });
                          }}
                      />
                  </div>
              </Modal>
              <VoteDialogAntd
                  ref={this.voteModal}
                  addContentVote={this.addContentVote}
                  imgInputChange={this.imgInputChange}
                  voteImgList={voteImgList}
              />
          </div>
      );
  }
}

const mapStateToProps = (state: IState) => {
    return {
        title: state.postBaseInfo.title,
        validAtMax: state.postBaseInfo.validAtMax,
        validAtMin: state.postBaseInfo.validAtMin,
        cover: state.postBaseInfo.cover,
        content: state.postContent,
        voteListTop: state.voteListTop,
        voteListbottom: state.voteListBottom,
        currentInputIndex: state.postUI.currentInputIndex,
        currentIndex: state.postUI.currentIndex,
        scrollTo: state.postUI.scrollTo,
        keyboradHeight: state.postUI.keyboradHeight,
        currentTarget: state.postUI.currentTarget,
        emojiVisible: state.postUI.emojiVisible,
        emojiBoxHeight: state.postUI.emojiBoxHeight,
        emptyViewHeight: state.postUI.emptyViewHeight,
        hasFocusTitle: state.postUI.hasFocusTitle,
        coverPixel: state.postBaseInfo.coverPixel,
        groupId: state.postBaseInfo.groupId,
    };
};
export default connect(mapStateToProps, {
    setTitle: action.setTitle,
    setValidAtMax: action.setValidAtMax,
    setValidAtMin: action.setValidAtMin,
    setContentByIndex: action.setContentByIndex,
    setCurrentInputIndex: action.setCurrentInputIndex,
    setCurrentIndex: action.setCurrentIndex,
    setCurrentTarget: action.setCurrentTarget,
    setMainScrollTop: action.setMainScrollTop,
    setHasFocusTitle: action.setHasFocusTitle,
    setKeyboradHeight: action.setKeyboradHeight,
    setSelectionEnd: action.setSelectionEnd,
    setEmptyViewHeight: action.setEmptyViewHeight,
    insertTitleByIndex: action.insertTitleByIndex,
    insertContentByIndex: action.insertContentByIndex,
    editTitleByIndex: action.editTitleByIndex,
    removeContentByIndex: action.removeContentByIndex,
    setCover: action.setCover,
    setCoverPixel: action.setCoverPixel,
    setContent: action.setContent,
    setVoteListTop: action.setVoteListTop,
    setVoteListBottom: action.setVoteListBottom,
    setGroupId: action.setGroupId
})(CreateEditPics);
